// Use tooltip components everywhere
$(function (){
    $(document).tooltip({
        selector: '[data-toggle=tooltip]',
        trigger: 'hover'
    });
});
